import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import project1 from "../images/tesla-clone.png";
import project2 from "../images/netflix-clone.png";
import project3 from "../images/chat-app.png";
import project4 from "../images/mern-stack.jpg";
import project5 from "../images/react-redux.jpg";
import project6 from "../images/react.png";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "#233",
    height: "100%",
  },
  cardContainer: {
    maxWidth: 345,
    margin: "3rem auto",
  },
}));

const projects = [
  {
    name: "Tesla Clone",
    description: `This project is a clone of Tesla's website made using the 
    React JavaScript Library. This project uses styled components and is
    mobile reponsive to cater for all users. For website hosting, the project
    uses Firebase hosting.`,
    image: project1,
    projectLink: "https://tesla-clone-79b56.web.app/",
    githubLink:"https://github.com/C0dingC0derr/tesla-clone",
  },
  {
    name: "Netflix Clone",
    description: `This project is a netflix clone which fetches data from
    an external data and stores that data in a piece of state. This is also
    mobile responsive, uses styled components and is hosted on Firebase.`,
    image: project2,
    projectLink: "https://netflix-clone-c55f4.web.app/",
    githubLink:"https://github.com/C0dingC0derr/Netflix-Clone",
  },
  {
    name: "Chat Application",
    description: `This project is chat application whereby users are able to create
    channels and dms and invite others into the respective group. The application is
    powered by firebase, allowing data created to persist.`,
    image: project3,
    projectLink: "https://chat-app-c4d51.web.app/",
    githubLink:"https://github.com/C0dingC0derr/chat-app",
  },
];

const Portfolio = () => {
  const classes = useStyles();
  return (
    <Box component="div" className={classes.mainContainer}>
      <Grid container justify="center">
        {/* Projects */}
        {projects.map((project, i) => (
          <Grid item xs={12} sm={8} md={4} key={i}>
            <Card className={classes.cardContainer}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  alt="Project 1"
                  height="140"
                  image={project.image}
                />
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {project.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {project.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <a href={project.githubLink} target="_blank">
                  <Button size="small" color="primary">
                    GitHub Link
                  </Button>
                </a>
                <a href={project.projectLink} target="_blank">
                  <Button size="small" color="primary">
                    Live Demo
                  </Button>
                </a>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Portfolio;
